import axios from "axios";

export default {
  getResult: function (baseApiUrl, eduCode, lang) {
    var response = axios.post(
      baseApiUrl +
        "/Utbildning/GetTillfallen?code=" +
        eduCode +
        "&lang=" +
        lang
    );
    return response;
  },
  anmalningsinfo: function (baseApiUrl, utbkod, tillfallesnamn, lang) {
    var response = axios.get(
      baseApiUrl +
        "/Utbildning/Anmalningsinfo?utbkod=" +
        utbkod +
        "&tillfallesnamn=" +
        tillfallesnamn +
        "&lang=" +
        lang 
    );
    return response;
  },
};
